import Cookies from 'js-cookie';

import { parseJSON } from 'hooks/useCookies';
import { isAccessTokenExpired } from 'modules/Authentication/utils/matrixTokenRefresh';
import { matrixConstants } from 'utils/Constants';

/** Read matrix session fields synchronously from cookies (avoids stale React state after pre-refresh). */
export const readMatrixSessionCookies = () => ({
  mxAccessToken: parseJSON<string>(Cookies.get(matrixConstants.MX_ACCESS_TOKEN) ?? null),
  mxRefreshToken: parseJSON<string>(Cookies.get(matrixConstants.MX_REFRESH_TOKEN) ?? null),
  mxAccessTokenExpiresAt: parseJSON<string>(Cookies.get(matrixConstants.MX_ACCESS_TOKEN_EXPIRES_AT) ?? null),
});

/** True when cookies hold a non-expired access token (e.g. after silent pre-refresh). */
export const hasValidMatrixAccessInCookies = (): boolean => {
  const { mxAccessToken, mxAccessTokenExpiresAt } = readMatrixSessionCookies();
  return !!(mxAccessToken && !isAccessTokenExpired(mxAccessTokenExpiresAt));
};

/** True when a failed start likely raced with a successful token refresh or client start. */
export const shouldSkipLogoutToastAfterFailedStart = ({
  matrixClientStarted,
}: {
  matrixClientStarted: boolean;
}): boolean => matrixClientStarted || hasValidMatrixAccessInCookies();
